import { AlertCircle } from 'lucide-react';

interface PageStateProps {
  title: string;
  message?: string;
  loading?: boolean;
}

export function PageState({ title, message, loading = false }: PageStateProps) {
  if (loading) {
    return <p className="p1-page-loading-status" role="status">{title}</p>;
  }

  return (
    <section className="p1-page-state is-error" role="alert">
      <span className="p1-page-state-icon" aria-hidden="true"><AlertCircle /></span>
      <div>
        <h1>{title}</h1>
        {message && <p>{message}</p>}
      </div>
    </section>
  );
}
